import React from "react";
import TransparentModal from "../../app/UI/Modal/TransparentModal";
import { closeModal } from "./modalActions";
import { connect } from "react-redux";

import OozeDailySalesReportSpinner from "../reports/Cachet/OozeDailySales/OozeDailySalesReportSpinner";

const actions = {
  closeModal,
};

const oozeDailySalesReportSpinnerModal = ({ closeModal }) => {
  return (
    <TransparentModal modalHeader="Please Wait...." onClose={closeModal}>
      <OozeDailySalesReportSpinner />
    </TransparentModal>
  );
};

export default connect(
  null,
  actions
)(oozeDailySalesReportSpinnerModal);
